import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

// Workaround: suppress noisy ResizeObserver loop error in some browsers/devtools
// This error is benign but the React error overlay stops the app in dev mode.
// We only stop propagation for ResizeObserver-related messages to avoid hiding real errors.
const _resizeObserverErrMsg1 = 'ResizeObserver loop completed with undelivered notifications.';
const _resizeObserverErrMsg2 = 'ResizeObserver loop limit exceeded';
window.addEventListener('error', (event) => {
  try {
    const msg = event?.message || '';
    if (typeof msg === 'string' && (msg.indexOf(_resizeObserverErrMsg1) !== -1 || msg.indexOf(_resizeObserverErrMsg2) !== -1)) {
      // Prevent the error from reaching the React error overlay
      event.stopImmediatePropagation();
      // Also prevent default to avoid console spam in some environments
      event.preventDefault();
    }
  } catch (e) {
    // swallow any error from our handler
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();